import { render, staticRenderFns } from "./SubjectLabelCategories.vue?vue&type=template&id=3485746b&scoped=true"
import script from "@/views/SubjectLabelCategories/SubjectLabelCategories.ts?vue&type=script&lang=ts&external"
export * from "@/views/SubjectLabelCategories/SubjectLabelCategories.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/SubjectLabelCategories/SubjectLabelCategories.scss?vue&type=style&index=0&id=3485746b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3485746b",
  null
  
)

export default component.exports